/**
 * Action Cable helper for live visit status (PayU notify → Medfile register).
 */
import { createConsumer } from '@rails/actioncable';

let consumer;

function getConsumer() {
  if (typeof window === 'undefined') return null;
  if (!consumer) consumer = createConsumer('/cable');
  return consumer;
}

/**
 * Subscribe to VisitChannel for a visit UUID.
 * @param {string} visitId
 * @param {(visit: object) => void} onUpdate
 * @returns {() => void} unsubscribe
 */
export function subscribeToVisit(visitId, onUpdate) {
  const cable = getConsumer();
  if (!cable || !visitId || typeof onUpdate !== 'function') return () => {};

  const subscription = cable.subscriptions.create(
    { channel: 'VisitChannel', id: String(visitId) },
    {
      received(data) {
        if (data?.visit) onUpdate(data.visit);
      },
    },
  );

  return () => {
    subscription.unsubscribe();
  };
}

/** True while the patient is still waiting for PayU / Medfile settlement. */
export function visitNeedsLiveUpdates(booking) {
  if (!booking?.id) return false;

  const paymentStatus = booking.payment?.status;
  const visitStatus = booking.visitStatus || booking.status;

  if (paymentStatus === 'pending') return true;
  if (visitStatus === 'pending_payment' || booking.status === 'pending_payment') return true;
  if (visitStatus === 'paid') return true; // paid but Medfile register may still land

  return false;
}
